import React from 'react'
import { Stack } from 'react-bootstrap'
import { Link, useLocation } from 'react-router-dom'

export default function ButtonNavigator(props) {
    const location = useLocation();

  return (
    <Stack direction='vertical' gap={2}>
        {   location.pathname === '/' ? 
            <Link role="button" aria-pressed="true" className='btn btn-outline-success active' to="/">Home</Link> :
            <Link role="button" className='btn btn-outline-success' to="/">Home</Link> 
        }
        {   location.pathname.startsWith("/tours") ? 
            <Link role="button" aria-pressed="true" className='btn btn-outline-success active' to="/tours">Tours</Link> :
            <Link role="button" className='btn btn-outline-success' to="/tours">Tours</Link> 
        }
        {   location.pathname.startsWith("/trips") ? 
            <Link role="button" aria-pressed="true" className='btn btn-outline-success active' to="/trips">Trips</Link> :
            <Link role="button" className='btn btn-outline-success' to="/trips">Trips</Link> 
        }
        {   location.pathname.startsWith("/rentals") ? 
            <Link role="button" aria-pressed="true" className='btn btn-outline-warning active' to="/rentals">Rentals</Link> :
            <Link role="button" className='btn btn-outline-warning' to="/rentals">Rentals</Link> 
        }
        {   location.pathname.startsWith("/shuttle") ? 
            <Link role="button" aria-pressed="true" className='btn btn-outline-warning active' to="/shuttle">Shuttle Service</Link> :
            <Link role="button" className='btn btn-outline-warning' to="/shuttle">Shuttle Service</Link> 
        }
        {   location.pathname.startsWith("/chauffeuring") ? 
            <Link role="button" aria-pressed="true" className='btn btn-outline-warning active' to="/chauffeuring">Chauffeur Service</Link> :
            <Link role="button" className='btn btn-outline-warning' to="/chauffeuring">Chauffeur Service</Link> 
        }
        {   location.pathname.startsWith("/arrangements") ? 
            <Link role="button" aria-pressed="true" className='btn btn-outline-warning active' to="/arrangements">Special Arrangement</Link> :
            <Link role="button" className='btn btn-outline-warning' to="/arrangements">Special Arrangements</Link> 
        }
        {   location.pathname.startsWith("/events") ? 
            <Link role="button" aria-pressed="true" className='btn btn-outline-danger active' to="/events">Events</Link> :
            <Link role="button" className='btn btn-outline-danger' to="/events">Events</Link> 
        }
        {   location.pathname.startsWith("/shopping") ? 
            <Link role="button" aria-pressed="true" className='btn btn-outline-danger active' to="/shopping">Shopping</Link> :
            <Link role="button" className='btn btn-outline-danger' to="/shopping">Shopping</Link> 
        }
        {   location.pathname.startsWith("/delivery") ? 
            <Link role="button" aria-pressed="true" className='btn btn-outline-danger active' to="/delivery">Delivery</Link> :
            <Link role="button" className='btn btn-outline-danger' to="/delivery">Delivery</Link> 
        }
    </Stack>
  )
}
